import {handleActions} from 'redux-actions';
import {Record, List} from 'immutable';

import * as Actions from './actions';

const State = Record({
    isVisible: false,
    isSearching: false,
    isLoading: false,
    institutionId: '',
    accountItemType: '',
    accountItemId: null,
    billPayerId: '',
    searchResults: List(),
});

export default handleActions(
    {
        [Actions.show.type]: (state, action) => {
            const payload = action.payload;
            return state.merge({
                isVisible: true,
                institutionId: payload.institutionId,
                billPayerId: payload.billPayerId,
                accountItemType: payload.accountItemType,
                accountItemId: payload.accountItemId,
            });
        },
        [Actions.hide.type]: () => State(),

        [Actions.moveInvoice.type]: state => state.merge({isLoading: true}),
        [Actions.moveInvoiceFailed.type]: state => state.merge({isLoading: false}),
        [Actions.moveInvoiceAborted.type]: state => state.merge({isLoading: false}),
        [Actions.moveInvoiceSuccess.type]: () => State(),

        [Actions.movePayment.type]: state => state.merge({isLoading: true}),
        [Actions.movePaymentFailed.type]: state => state.merge({isLoading: false}),
        [Actions.movePaymentAborted.type]: state => state.merge({isLoading: false}),
        [Actions.movePaymentSuccess.type]: () => State(),

        [Actions.search.type]: state =>
            state.merge({
                isSearching: true,
            }),
        [Actions.searchSuccess.type]: (state, {payload}) =>
            state.merge({
                searchResults: payload.billPayers,
                isSearching: false,
            }),
        [Actions.searchAborted.type]: state =>
            state.merge({
                isSearching: false,
            }),
        [Actions.searchFailed.type]: state =>
            state.merge({
                isSearching: false,
            }),
    },
    State(),
);
